import { ListingSectionObject } from '../transports/common/listing-section-transport'
import { BookingTypeEnum } from '../models/property-details-page/booking-type-model'
import { Provider } from '../models/property-details-page/contact-model'
import { encodeToBase64 } from './encoding-utils'

export interface BulkInquiryCheckoutStay {
    arrival?: string
    departure?: string
    adults?: number
    children?: number
}

export function isBulkInquiryEligible(listing: ListingSectionObject): boolean {
    if (listing.externalPartnerInfo) {
        return false
    }

    if (listing.isComboListing) {
        return false
    }

    if (listing.providerId === String(Provider.PROVIDER_HOMETOGO)) {
        return false
    }

    return listing.bookingType !== BookingTypeEnum.DIRECT_BOOKING
}

export function buildBulkInquiryCheckoutUrl(
    checkoutPath: string,
    listingIds: string[],
    filter: string,
    stay: BulkInquiryCheckoutStay,
): string {
    const params = new URLSearchParams()
    listingIds.forEach(id => params.append('listingIds', id))
    params.set('filter', encodeToBase64(filter))

    if (stay.arrival) {
        params.set('arrival', stay.arrival)
    }
    if (stay.departure) {
        params.set('departure', stay.departure)
    }
    if (stay.adults) {
        params.set('adults', String(stay.adults))
    }
    if (stay.children !== undefined) {
        params.set('children', String(stay.children))
    }

    return `${checkoutPath}?${params.toString()}`
}
